// @ts-expect-error no imports yet
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
function ApprovalUserAvatar(props) {
  const {
    approvalUser
  } = props;
  const {
    email
  } = approvalUser;
  return /*#__PURE__*/_jsx(UIAvatar, {
    "data-test-id": "approval-user-avatar",
    size: "md",
    hubSpotUserEmail: approvalUser.email,
    displayName: email
  });
}
export default ApprovalUserAvatar;